import client, { PUBLIC_CLIENT, PRIVATE_CLIENT } from '../../services/client';
import authStore from '../../store/auth';
import sessionStore from '../../store/session';
import userStore from 'store/user';

export const loginRequestOtpAction = async (mobile) => {
    if (mobile.startsWith('0')) {
        mobile = mobile.replace('0', '+234');
    } else if (mobile.startsWith('234')) {
        mobile = mobile.replace('234', '+234');
    }

    const response = await client.post('login/', PUBLIC_CLIENT, {
        mobile,
    });

    return response;
};

export const logoutAction = async () => {
    const response = await client.post('auth/logout/', PRIVATE_CLIENT);

    authStore.logout();
    sessionStore.logout();
    userStore.logout();

    return response;
};

export const loginVerifyOtpAction = async (mobile, token) => {
    if (mobile.startsWith('0')) {
        mobile = mobile.replace('0', '+234');
    }

    const response = await client.post('auth/token/', PUBLIC_CLIENT, {
        mobile,
        token,
    });

    authStore.login(response);

    return response;
};

export const getRefreshToken = async () => {
    try {
        const response = await client.post(`auth/token/refresh/`, PUBLIC_CLIENT);
        authStore.login(response);
        return response;
    } catch(_){}
};

export const getBalance = async () => {
    const response = await client.get('users/balance/');

    sessionStore.setBalance(response.balance);
};
